import React from "react";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";

const tiers = [
  {
    id: "free",
    name: "Amateur Chef",
    price: "0€/mo",
    desc: "Basic access: generate recipes with limited usage.",
    features: ["7 Recipes / Week", "Access to core features"],
  },
  {
    id: "pro",
    name: "Sous Chef",
    price: "3€/mo",
    desc: "For home cooks who want faster results and higher limits.",
    features: ["50 Recipes / Week", "Priority Generation", "Email support"],
  },
  {
    id: "team",
    name: "Head Chef",
    price: "9€/mo",
    desc: "Complete experience: more recipes, added macros and costs.",
    features: ["100 Recipes  /Week", "Priority Generation", "Priority support", "Added Featrues: Macros + Micros + Estimated Cost"],
  },
];

const Subscription: React.FC = () => {
  return (
    <div className="min-h-screen bg-background p-6 md:p-12">
      <div className="mx-auto max-w-5xl">
        <div className="mb-8 text-center">
          <h1 className="mb-2 text-4xl font-bold text-foreground">Subscription Plans</h1>
          <p className="text-lg text-muted-foreground">Choose a plan that fits your cooking needs.</p>
        </div>

        <div className="grid gap-6 md:grid-cols-3">
          {tiers.map((tier) => (
            <Card key={tier.id} className="p-6 flex flex-col justify-between min-h-[220px]">
              <div className="flex items-center justify-between">
                <div>
                  <h3 className="text-xl font-semibold text-foreground">{tier.name}</h3>
                  <p className="mt-1 text-sm text-muted-foreground">{tier.desc}</p>
                </div>
                <div className="text-right">
                  <div className="text-lg font-bold text-foreground">{tier.price}</div>
                </div>
              </div>

              <ul className="mt-4 space-y-2 text-sm text-foreground">
                {tier.features.map((f) => (
                  <li key={f} className="flex items-start gap-2">
                    <span className="mt-0.5 text-primary">•</span>
                    <span>{f}</span>
                  </li>
                ))}
              </ul>

              <div className="mt-6">
                <Button size="lg" className="w-full">Select</Button>
              </div>
            </Card>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Subscription;
